import { render, staticRenderFns } from "./WideWithoutFooterLayout.vue?vue&type=template&id=5e55b43e&scoped=true&"
import script from "./WideWithoutFooterLayout.vue?vue&type=script&lang=js&"
export * from "./WideWithoutFooterLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e55b43e",
  null
  
)

export default component.exports